module.exports = __webpack_public_path__ + "static/media/icon_people.6d9347dd.svg";